import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPageNo, setTransectionType } from '../features/filter/filterSlice';

const digitToArray = (digit) => {
  let arr = [];

  for (let i = 0; i < digit; i++) {
    arr = [...arr, 1];
  }

  return arr;
};

export default function Pagination({ allTransactions, transactions }) {
  const dispatch = useDispatch();

  const { pageNo, search } = useSelector((state) => state.filter);

  const handlePageClick = (e) => {
    dispatch(setPageNo(+e.target.innerText));
    dispatch(setTransectionType(""));
  };

  const pageTabArr = search
    ? digitToArray(Math.ceil(transactions?.length / 5))
    : digitToArray(Math.ceil(allTransactions?.length / 5));

  return (
    <>
      <section className="pt-12">
        <div className="flex-center">
          {pageNo > 0 &&
            allTransactions?.length > 0 &&
            pageTabArr.map((itm, index) => {
              return (
                <div
                  key={index}
                  className={`${index + 1 === pageNo ? `expense` : `income`
                    } page-item`}
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePageClick(e);
                  }}
                >
                  {index + 1}
                </div>
              );
            })}
        </div>
      </section>
    </>
  );
}
